var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"text-left table-header"},[_vm._v(" "+_vm._s(_vm._f("i18n")(_vm.header))+" ")]),_c('Table',{attrs:{"columns":_vm.columns,"rows":_vm.items,"pagination":false,"on-row-click":_vm.rowClick,"tableName":"oneBaseTable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }